// extracted by mini-css-extract-plugin
export default {"root":"Slider_root__IAuXf","bar":"Slider_bar__P9Mc5","fill":"Slider_fill__ZilhL","handle":"Slider_handle__Pmg5R","thumb":"Slider_thumb__liafn","label":"Slider_label__4x5r6"};